export default "__VITE_ASSET__3661c5a7__"